import { makeObservable, observable, action, configure, runInAction } from 'mobx';
import type { Item } from 'root/types/item';
import { ItemState as SingleItemState } from './ItemState';

configure({ isolateGlobalState: true });

export class ItemState {
  itemMap: Map<string, Item> = new Map();
  itemsStateMap: Map<string, SingleItemState> = new Map();
  isLoading = true;
  constructor() {
    makeObservable(this, {
      isLoading: observable,
      itemMap: observable,
      itemsStateMap: observable,
      setItemMap: action,
      setIsLoading: action,
    });
  }

  // For unit test purposes
  _syncSetIsLoading(loading: boolean) {
    this.isLoading = loading;
  }

  setIsLoading(loading: boolean) {
    setTimeout(() => {
      runInAction(() => {
        this.isLoading = loading;
      });
    }, 500);
  }

  setItemMap(items: Map<string, Item>) {
    this.itemMap = items;
  }

  setItemsStateMap(items: Item[]) {
    runInAction(() => {
      this.itemsStateMap = new Map(items.map((item) => [item.id, new SingleItemState(item)]));
    });
  }

  getSingleItemState(itemId: string): SingleItemState | undefined {
    return this.itemsStateMap.get(itemId);
  }

  clearItemsState() {
    runInAction(() => {
      this.itemsStateMap.clear();
    });
  }

  get modifiersQuantity() {
    return [...this.itemMap.values()].reduce(
      (acc, item) =>
        acc + item.modifierGroups.reduce((accG, group) => accG + group.modifiers.length, 0),
      0
    );
  }

  get variantsQuantity() {
    return [...this.itemMap.values()].reduce(
      (acc, item) => acc + (item.priceVariants?.variants?.length ?? 0),
      0
    );
  }

  get labelsQuantity() {
    return [...this.itemMap.values()].reduce((acc, item) => acc + item.labels.length, 0);
  }
}

export const itemState = new ItemState();
